module.exports = __webpack_public_path__ + "img/bcp.d1d0a07f.svg";